import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "../css/Navbar.css";

export default function NavbarBoot({ userData, setUserData }) {
  const { usertype } = userData;
  const navigate = useNavigate();
  const handleLogout = () => {
    sessionStorage.clear();
    setUserData("");
    navigate("/");
    document.body.classList.remove("opacitypage");

  };


  return (
    <Navbar expand="lg" className="menubar ">
      <Container>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse
          id="basic-navbar-nav"
          className="justify-content-evenly"
        >
          <Nav className="d-flex gap-lg-5 ">
            <NavLink to={"/Dashboard"} className="nav-link-no-underline">Dashboard</NavLink>
            <NavLink to={"/Home"} className="nav-link-no-underline">Home</NavLink>
            {usertype === 1 || usertype === 6 || usertype === 7  ? (
              ""
            ) : (
              <>
                <NavLink to={"/Upload"}className="nav-link-no-underline">Excel Upload</NavLink>
              </>
            )}
            <NavLink to={"/ContactUs"} className="nav-link-no-underline">Contact Us</NavLink>
          </Nav>
        </Navbar.Collapse>
        {/* <NavLink className="nav-link-no-underline">
        
          <button
            type="button"
            onClick={handleLogout}
            className="logout-button"
            aria-label="Logout"
          >
            Logout
          </button>
        </NavLink> */}
      </Container>
    </Navbar>
  );
}
